<!--
移动端：选择组件。pupop+picker

<template>
  <div>
    <el-button @click="visible = true">{{name}}</el-button>
    <m-picker v-model="value" :visible.sync="visible" title="select" show-toolbar :columns="columns" :custom-field="{value: 'id', label: 'label'}" @confirm="confirm" />
  </div>
</template>

<script>
import Picker from '@/components/mobile/Picker.vue'
export default {
  components: { 'm-picker': Picker },
  data() {
    return {
      value: 3,
      visible: false,
      columns: [
        { id: 1, name: 'jack' },
        { id: 2, name: 'tom' },
        { id: 3, name: 'bob' }
      ]
    }
  },
  methods: {
    confirm(value, row) {}
  }
}
</script>
-->

<template>
  <van-popup v-model="visible" position="bottom" @close="close">
    <van-picker v-bind="$attrs" :columns="columns.map(item => item[customField.label])" :default-index="defaultIndex" confirm-button-text="Confirm" cancel-button-text="Cancel" @confirm="confirm" @cancel="close"></van-picker>
  </van-popup>
</template>

<script>
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'

import picker from 'vant/lib/picker'
import 'vant/lib/picker/style'

export default {
  components: { 'van-popup': popup, 'van-picker': picker },
  model: {
    prop: 'value',
    event: 'valueChange'
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    customField: {
      type: Object,
      default: () => ({ value: 'value', label: 'label' })
    }
  },
  computed: {
    defaultIndex() {
      return this.columns.findIndex(item => item[this.customField.value] === this.value) || 0
    }
  },
  methods: {
    confirm(value, index) {
      const item = this.columns[index]
      this.$emit('valueChange', item[this.customField.value])
      this.$emit('confirm', item[this.customField.value], item)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
